export default{
  shortUrl: [],
  url: '',
  logs: [],
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  size: 200,
  pagination: {
    current_page: 0,
    number_of_elements: 0,
    total_elements: 0,
    total_pages: 0
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/splitTest/state.js